import { useTranslation } from "react-i18next"
import { passwordRegex } from "@/app/account/constants/regex"

export default function useGetNewPwdErrMsg(pwd?: string, newPwd?: string) {
  const { t } = useTranslation("")

  if (pwd === undefined || newPwd === undefined) {
    return
  }

  if (newPwd === "") {
    return t("rules.required")
  }

  if (pwd === newPwd) {
    return t("rules.samePassword")
  }

  if (!passwordRegex.test(newPwd as string)) {
    return t("rules.passwordError")
  }
}
